<template>
  <v-layout mt-2 text-xs-center wrap>
    <v-flex xs12>
      <v-card>
        <v-card-title primary-title class="justify-center">
          <div>
            <h1 class="headline">Health Check</h1>
            <div v-if="!loadingHealth">
              <div class="my-2">
                <h3>
                  API Connection:
                  <v-icon style="color:green;" v-show="apiConnection === 'UP'">check_circle_outline</v-icon>
                  <v-icon style="color:red;" v-show="apiConnection === 'DOWN'">error_outline</v-icon>
                  <v-icon style="color:gray;" v-show="apiConnection === 'UNKNOWN'">help_outline</v-icon>
                </h3>
              </div>
              <div class="my-2">
                <h3>
                  DB Connection:
                  <v-icon style="color:green;" v-show="dbConnection === 'UP'">check_circle_outline</v-icon>
                  <v-icon style="color:red;" v-show="dbConnection === 'DOWN'">error_outline</v-icon>
                  <v-icon style="color:gray;" v-show="dbConnection === 'UNKNOWN'">help_outline</v-icon>
                </h3>
              </div>
              <div class="my-2">
                <h3>
                  S3 Connection:
                  <v-icon style="color:green;" v-show="s3Connection === 'UP'">check_circle_outline</v-icon>
                  <v-icon style="color:red;" v-show="s3Connection === 'DOWN'">error_outline</v-icon>
                  <v-icon style="color:gray;" v-show="s3Connection === 'UNKNOWN'">help_outline</v-icon>
                </h3>
              </div>
            </div>
            <div v-else>
              <h3>Loading health...</h3>
            </div>
          </div>
        </v-card-title>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-show="!loadingHealth" text @click="getHealth">Refresh Health</v-btn>
        </v-card-actions>
      </v-card>
    </v-flex>
  </v-layout>
</template>

<script>
import axios from "axios";

export default {
  name: "Health",
  computed: {
    getBaseUrl() {
      return this.$store.getters.getBaseUrl;
    }
  },
  mounted() {
    this.getHealth();
  },
  data: () => ({
    dbConnection: null,
    s3Connection: null,
    apiConnection: null,
    loadingHealth: true
  }),
  methods: {
    getHealth() {
      this.loadingHealth = true;
      let config = {
        url: `${this.getBaseUrl}/health`,
        method: "GET"
      };

      axios(config)
        .then(response => {
          this.loadingHealth = false;
          if (response.status === 200) {
            this.apiConnection = "UP";
            if (response.data.s3Connection) {
              this.s3Connection = "UP";
            } else {
              this.s3Connection = "DOWN";
            }
            if (response.data.dbConnection) {
              this.dbConnection = "UP";
            } else {
              this.dbConnection = "DOWN";
            }
          } else {
            this.apiConnection = "DOWN";
            this.s3Connection = "UNKNOWN";
            this.dbConnection = "UNKNOWN";
          }
        })
        .catch(err => {
          this.loadingHealth = false;
          this.apiConnection = "DOWN";
          this.s3Connection = "UNKNOWN";
          this.dbConnection = "UNKNOWN";
        });
    },
    resetHealth() {
      this.apiConnection = null;
      this.s3Connection = null;
      this.dbConnection = null;
    }
  }
};
</script>


<style scoped>
</style> 


